/**
 * @see https://tkdodo.eu/blog/effective-react-query-keys#use-query-key-factories
 */
export const MaterQueryKeys = {
  all: ['user'] as const,
  lists: () => [...MaterQueryKeys.all, 'list'] as const,
  list: (filters: object) => [...MaterQueryKeys.lists(), { filters }] as const,
  details: () => [...MaterQueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...MaterQueryKeys.details(), id] as const,
};
